export function mathRound(value) {
  return Math.round(value * 100) / 100;
}

export function formatNumber(value) {
  return new Intl.NumberFormat("it-IT", {
    maximumFractionDigits: 2,
  }).format(value);
}